import React, { Component, Fragment } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import CadeComponentHeader from './CadeComponentHeader';
import CadeComponentDoodle from './CadeComponentDoodle';
import CadeAnalyzeRecommendations from './CadeAnalyzeRecommendations';
import CadeAnalyzeRadar from './CadeAnalyzeRadar';
import CadeAnalyzePie from './CadeAnalyzePie';
import authService from '../../services/AuthService';
import api, { apiErrorHandler, apiResponseHandler } from '../../services/AxiosService';


import './CadeAnalyze.css';
import { apiErrorPopup } from '../../helpers/MessagePopup';


class CadePartnerAnalyzeAssessmentComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            assessmentId: props.assessmentId,
            cadeModeFor: props.cadeModeFor,
            numUnansweredItems: 0,
            numFlags: 0,
            flagConcernLevel: "",
            flagThresholdText: "",
            asdScore: 0,
            asdConcern: "No Concern",
            domainConcerns: [],
            asdLevels: [],
            concerns: []
        }
    }

    componentDidMount = () => {
        /*
         * Run a query to get an AsdAssessmentModel
         */

        let url = "assessment/" + this.state.assessmentId +  "/caiu/" + authService.authenticatedUserId + "/partneranalyze/" + this.state.cadeModeFor;
        api.get(url, {
            headers: {
                Authorization: 'Bearer ' + authService.token
            }
        })
            .then((response) => {
                if (response.status === 200) {
                    this.setState({
                        numUnansweredItems: response.data.numUnansweredItems,
                        numFlags: response.data.numFlags,
                        flagConcernLevel: response.data.flagConcernLevel,
                        flagThresholdText: response.data.flagThresholdText,
                        domainConcerns: response.data.domainConcerns,
                        concerns: response.data.concerns
                    });
                }
                else {
                    apiErrorPopup(apiResponseHandler(response));
                }
            })
            .catch(error => {
                // Major problem - should not happen.  Back to login?
                apiErrorPopup(apiErrorHandler(error));
            });
    }

    render() {
        let domainTitle = "Clear Child Assessment Summary";
        let domainDesc = null;
        let headerTitle = (this.state.numUnansweredItems == 0) ? "Clear Child Concern Level: " + this.state.flagConcernLevel : "Unable to Complete Clear Child Assessment: " + this.state.numUnansweredItems + " Unanswered Items";
        const pieData = [{ name: 'Concerns', value: this.state.concerns.length }, { name: "Flagged Concerns", value: this.state.numFlags }];
        const COLORS = ['#1D64AE', '#F9922C'];
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentHeader
                                cadeDomain={domainTitle}
                                subTitle={domainDesc}
                            />
                        </Col>
                        <Col sm={8}>
                        </Col>
                    </Row>
                    <Row>
                        <Col sm={4}>
                            <CadeComponentDoodle
                                domainImage="CadeAssessmentLG.png"
                                resClickHandler={null}
                                resources={null}
                                resKey={0}
                            />
                            {this.state.numUnansweredItems == 0 &&
                                <Fragment>
                                <p></p>
                                    <p className='cadeAnalyze_partnerConcernLevel'>Clear Child Concern Level: {this.state.flagConcernLevel}</p>
                                    <p className='cadeAnalyze_flagInfo'>Number of Concerns: {this.state.concerns.length}</p>
                                    <p className='cadeAnalyze_flagInfo'>Number of Flagged Concerns: {this.state.numFlags}</p>
                                    <p className='cadeAnalyze_flagThreshold'>{this.state.flagThresholdText}</p>
                                </Fragment>
                            }
                        </Col>
                        <Col sm={8}>
                            <Row>
                                <Col sm={12}>
                                    <h4>{headerTitle}</h4>
                                </Col>
                            </Row>

                            {this.state.numUnansweredItems == 0 &&
                                <Row>
                                    <Col sm={6}>
                                        <CadeAnalyzePie
                                            height={300}
                                            pieData={pieData}
                                            pieColors={COLORS}
                                        />
                                    </Col>
                                    <Col sm={6}>
                                    </Col>
                                </Row> 
                            }
                        </Col>
                    </Row>

                    {this.state.numUnansweredItems == 0 &&
                        <Row>
                            <Col sm={12}>
                                <CadeAnalyzeRadar
                                    cadeModeFor={this.props.cadeModeFor}
                                    radarName="Domain Concerns"
                                    concernLevel={this.state.flagConcernLevel}
                                    domainConcerns={this.state.domainConcerns}
                                    outerRadius={200}
                                />
                            </Col>
                        </Row>
                    }

                    {this.state.numUnansweredItems == 0 &&
                        <Row>
                            <Col sm={12}>
                            <CadeAnalyzeRecommendations
                                heading="Summary of Clear Child Recommendations"
                                concerns={this.state.concerns}
                                displayFlags={true}
                            />
                            </Col>
                        </Row>
                    }
                </Container>

            </Fragment>
        );
    }
}

export default CadePartnerAnalyzeAssessmentComponent;



// WEBPACK FOOTER //
// ./src/components/CadeComponent/CadePartnerAnalyzeAssessmentComponent.js